export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/certificate.1aa44fe8.svg","height":120,"width":167,"blurWidth":0,"blurHeight":0};